import {
  CommandKeyDecoration,
  ShortcutKey,
} from '~/components/command-menu/components/ShortcutDecoration'

type FooterAction = {
  shortcuts: ShortcutKey[]
  label: string
}

export const CommandMenuFooter = ({ actions }: { actions: FooterAction[] }) => (
  <div className="flex w-full items-center justify-between border-t border-gray-100 p-2 px-3 dark:border-gray-800">
    {actions.map((action) => (
      <div
        key={action.label}
        className="flex items-center gap-1.5 text-xs text-secondary"
      >
        {action.shortcuts.map((shortcut) => (
          <CommandKeyDecoration key={shortcut} shortcut={shortcut} />
        ))}
        <span>{action.label}</span>
      </div>
    ))}
  </div>
)
